import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import temp from "../assets/images/user-icon.jpg";
import { IoMdLogOut } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaWhatsapp } from "react-icons/fa";

const Navbar = () => {
  const { user } = useSelector((state) => state.user);
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const logout = () => {
    localStorage.removeItem("sml-platform-user");
    navigate("/login", { replace: true });
  };
  return (
    <>
      <nav className="mb-2">
        <div className="container p-0">
          {user.Account_Status.toLowerCase() === "enrolled" ? (
            <div className="nav-logo">
              <img src={logo} alt="" />
            </div>
          ) : (
            location.pathname !== "/user_cibil" &&
            user.CIBIL_Check === true && (
              <Link to="/user_cibil" className="button text-capitalize">
                Check credit score
              </Link>
            )
          )}

          <div className="nav-right">
            <div className="nav-pic">
              <img src={temp} alt="" />
            </div>
            <a
              href="https://api.whatsapp.com/send?phone=918657953453&text=Hi!%20Please%20share%20more%20information%20about%20the%20debt%20settlement%20services%20offered%20by%20Settle%20My%20Loan.%0A"
              target="_blank"
              className="secondary-button"
            >
              <FaWhatsapp />
            </a>
            <button
              className="red-button"
              onClick={() => setModalVisible(true)}
            >
              <IoMdLogOut />
            </button>
          </div>
        </div>
      </nav>

      <div className={`modal-background ${modalVisible ? "active" : ""}`}>
        <div className="modal-container py-4" style={{ maxWidth: "300px" }}>
          <h2 className="text-center mb-3">Logout?</h2>
          <div className="d-flex align-items-center justify-content-center gap-2">
            <button
              className="red-button"
              style={{ width: "60px" }}
              onClick={logout}
            >
              Yes
            </button>
            <button
              className="button"
              style={{ width: "60px" }}
              onClick={() => setModalVisible(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
